import Holidays from "date-holidays";
import moment from "moment";
import { momentLocalizer } from "react-big-calendar";

export const getFilteredHolidays = () => {
  const holidays = new Holidays("CA").getHolidays();
  return holidays.filter(
    (day) =>
      day.type === "public" &&
      day.name !== "National Day for Truth and Reconciliation" &&
      day.name !== "Remembrance Day"
  );
};

export const setupMomentLocalizer = () => {
  moment.locale("en-CA", {
    week: {
      dow: 1,
      doy: 1,
    },
  });

  return momentLocalizer(moment);
};

export const isDateOnHoliday = (date, filteredHolidays) => {
  for (let i in filteredHolidays) {
    if (filteredHolidays[i].start == null) {
    } else if (
      filteredHolidays[i].start.withoutTime().toString() ===
      date.withoutTime().toString()
    ) {
      return true;
    }
  }
  return false;
};
